import { render, staticRenderFns } from "./ListaAcoes.vue?vue&type=template&id=69825a34"
import script from "./ListaAcoes.vue?vue&type=script&lang=js"
export * from "./ListaAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports